import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../images/solution/on-demand-new/banner_ondemand.webp";

function Banner(props) {
  // Function to handle the scroll action
  const scrollToCaseStudies = () => {
    const caseBtnElement = document.getElementById("case_btn");
    if (caseBtnElement) {
      // Using `scrollIntoView` to scroll to the target element
      caseBtnElement.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div
      className="service_usa web_dev_service on_demand_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner">
                On Demand App Development Company
              </h1>
              <span>Dynamic, High-Impact On-Demand Service Apps</span>
              <p>
                Fit in all your business offerings on a single platform with
                personalized experience at every step through our on-demand
                mobile app development services. We build applications tailored
                to your business and target audience. Using a progressive tech
                stack and hybrid development frameworks, we accelerate
                turnarounds and enhance your app's capabilities.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Consult Now
              </Link>
              <button
                className="border_btn web_case_btn"
                aria-label="TekRevol Contact"
                onClick={scrollToCaseStudies}
              >
                Case Studies
              </button>
            </div>
          </Col>
          <Col
            xs={12}
            md={5}
            lg={6}
            xl={5}
            xxl={5}
            className="my-auto text-center"
          >
            <div className="on_demand_mob">
              <StaticImage
                src="../../images/solution/on-demand-new/on_demand_new_mob.webp"
                alt="on demand app development company"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={740}
                height={680}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
